import { useEffect, useState } from 'react';
import { invigilationApi } from '../lib/invigilationApi';
import { MyDutiesStrip } from '../components/MyDutiesStrip';

/**
 * A member of staff's own duty list, on its own screen.
 *
 * ⚠ THE STRIP RENDERS NOTHING WHEN THERE IS NOTHING — which is right when it sits on a dashboard
 * and wrong here, where a person navigated on purpose and a blank page reads as broken. So this
 * page asks the same question a second time only to decide which empty state to show. Two calls,
 * both cheap, and the alternative is a strip that has to know where it is being rendered.
 */
export function MyDutiesPage() {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let alive = true;
    invigilationApi
      .mine(undefined, 60)
      .then((r) => alive && setCount(r.length))
      .catch(() => alive && setCount(0));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="inv">
      <header className="inv-head">
        <h1>My duty</h1>
        <p className="inv-sub">
          Examination duty assigned to you and published by the school. Draft charts are not shown —
          if it is here, it is on the noticeboard.
        </p>
      </header>

      <MyDutiesStrip days={60} />

      {count === 0 && (
        <div className="card inv-empty">
          <p><strong>You have no invigilation duty in the next sixty days.</strong></p>
          <p className="inv-sub">
            Duty appears here as soon as the school publishes the chart for an examination day.
          </p>
        </div>
      )}
    </div>
  );
}
